module.exports = __webpack_public_path__ + "static/media/1417963310.b3addfed.ttf";